import type { CContactFormTranslations } from "./pl";

export const en: CContactFormTranslations = {
  noConfig: "Form configuration data is missing.",
  crmModeWithoutModule: {
    body1: "The form is configured to send to CRM, but the module",
    moduleName: "m_crm_sales_support",
    body2:
      'is not active in this domain. Enable the module in the admin panel or change the send mode to "email" in the catalog configuration.',
  },
  unknownSendMode: (mode) =>
    `Unknown send mode in form configuration: ${mode}.`,

  contactUsingForm: "Contact form",
  labels: {
    text: "Message",
  },
  send: "Send",
  sending: "Sending…",

  sectionHeaders: {
    personal: "Personal data",
    company: "Company data",
  },

  validation: {
    requiredField: (label) => `Field "${label}" is required.`,
    invalidEmail: "Invalid email address.",
    invalidUrl: "URL must start with http:// or https://.",
    invalidPhone: "Invalid phone number.",
    invalidNip: "Tax ID must contain 10 digits.",
    requiredText: 'Field "Message" is required.',
    requiredPersonalData: "Consent to personal data processing is required.",
  },

  map: {
    directionsLink: "Get directions ->",
    openInOpenStreetMap: "Open in OpenStreetMap ->",
  },

  status: {
    waitBeforeSubmit: (seconds) =>
      `Please wait ${seconds} more seconds before submitting.`,
    rateLimit: "Too many attempts from this IP address. Try again in a moment.",
    sendFailed: "Failed to send the message.",
    sendSuccess: "Message sent, thank you!",
    networkError: (message) => `Network error: ${message}`,
    networkErrorGeneric: "Network error while sending.",
  },
};
